package com.appcreator.theme

import androidx.compose.material3.Typography

val AppTypography = Typography()
